export default __webpack_public_path__ + "static/media/see-shortened.5c833623.svg";